import {IController, IFormController, IModule, IPromise} from "angular";
import {Møtevalideringsfeil, NyttMøteSkjemaModell} from "../../MøteTjeneste";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {Debugger} from "debug";

const debug: Debugger = require('debug')('NyttMøteDetaljerSkjemaKontroller');
const css = require('./nyttMøteDetaljerSkjema.scss');

export class NyttMøteDetaljerSkjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmNyttMoeteDetaljerSkjema', {
            bindings: {
                nyttMoeteModell: '<',
                skjema: '<',
                validerSpesifikasjon: '&',
                vedOpprettAarsplan: '&?'
            },
            controller: NyttMøteDetaljerSkjemaKontroller.forInjisering(),
            template: require('./nyttMøteDetaljerSkjema.html')
        });
    }

    static forInjisering() {
        return [
            NyttMøteDetaljerSkjemaKontroller
        ]
    }

    constructor() {
    }

    nyttMoeteModell: NyttMøteSkjemaModell; //settes via bindings
    skjema: IFormController; //settes via bindings
    validerSpesifikasjon: (args: { spesifikasjon: l.NyttMøteSpesifikasjon }) => IPromise<Møtevalideringsfeil>; //settes via bindings
    vedOpprettAarsplan: (args: {gruppeId:string; periode:l.PlanPeriode}) => void; //settes via bindings, merk at denne er ikke null selvom attributtet ikke er angitt

    validerMoetedato(dato: l.MøteDato) :IPromise<Møtevalideringsfeil>{
        const spesifikasjon = this.nyttMoeteModell.somNyttMøteSpesifikasjon();
        spesifikasjon.dato = dato;
        return this.validerSpesifikasjon({spesifikasjon: spesifikasjon});
    }

    //hjelpemetoder

}
